<div class="micro-protocol-header">
  <div class="micro-protocol-header__grid">
    <span class="micro-protocol-header__name">{{ title }}</span>
    <span class="micro-protocol-header__count micro-protocol-header__count--asset">
      {{ assetTotalCount | compactNumber }}
    </span>
    <span class="micro-protocol-header__pct micro-protocol-header__pct--asset">
      {{ assetTotalPct | number : '1.0-1' }}%
    </span>
    <span class="micro-protocol-header__count micro-protocol-header__count--sample">
      {{ sampleTotalCount | compactNumber }}
    </span>
    <span class="micro-protocol-header__pct">{{ sampleTotalPct | number : '1.0-1' }}%</span>
  </div>
</div>
